import { Component, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { SessionService } from '@fi-app/utilities/fi-services/session.service';
import { TemplateLayoutLanguageService } from '@fi-app/template/template-layout-language.service';
import { AccessRightFilterSettings } from '@fi-shared/access-right-filters';
import { ModuleType } from '@fi-shared/types/module-type';
import { AppTextService } from '@fi-shared/app-text';
import { AccessRightFiltersComponent } from '@fi-shared/access-right-filters/access-right-filters.component';
import { FiCustomerDataService } from '@fi-shared/fi-shared-services/fi-customer-data.service';
import { ObjectTypes } from '@fi-shared/types';

@Component({
    selector: 'fi-document-template-edit-general',
    templateUrl: './document-template-edit-general.component.html',
    styleUrls: ['./document-template-edit-general.component.scss'],
    host: { class: 'fi-document-template-edit-general' },
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class FiDocumentTemplateEditGeneralComponent implements OnInit {
    @Input() isTooltipHidden: boolean;

    @ViewChild(AccessRightFiltersComponent, { static: false }) accessRightFilters: AccessRightFiltersComponent;

    constructor(
        private sessionService: SessionService,
        private templateLayoutLanguageService: TemplateLayoutLanguageService,
        private appTextService: AppTextService,
        private customerDataService: FiCustomerDataService,
    ) {}

    @Input('template') Template;

    ShowLanguageSelector: boolean;
    ActiveItem;
    AccessRightFilterSettings = new AccessRightFilterSettings(ModuleType.Template, false, true, ObjectTypes.Template);

    ngOnInit() {
        this.ShowLanguageSelector = this.customerDataService.customerData.ContentLanguages.length > 1;
    }

    IsDefaultLanguage(ContentLanguageId) {
        return this.templateLayoutLanguageService.IsDefaultLanguage(ContentLanguageId);
    }

    isTemplateNameRequired(): boolean {
        return !this.Template.Names.some((name) => name.Value);
    }

    NamePlaceholder() {
        return this.isTemplateNameRequired()
            ? this.appTextService.get('common.required')
            : this.findDefaultLanguageValue(this.Template.Names);
    }

    DescriptionPlaceholder(contentDescr) {
        return this.IsDefaultLanguage(contentDescr.ContentLanguageId)
            ? ''
            : this.findDefaultLanguageValue(this.Template.Descriptions);
    }

    findDefaultLanguageValue(itemsArray) {
        const DefaultLanguageId = this.templateLayoutLanguageService.GetDefaultLanguageId();
        const item = itemsArray.find((item) => item.ContentLanguageId === DefaultLanguageId);
        if (item) return item.Value;
    }
}
